<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div
    data-slot="section-header-actions"
    :class="
      cn(
        'mt-2 flex flex-wrap items-center gap-2 lg:col-start-2 lg:row-start-1 lg:row-end-3 lg:mt-0 lg:self-end lg:justify-end',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>
